module.exports = __webpack_public_path__ + "img/icon (15).324543b7.png";